import { render, staticRenderFns } from "./formClientDelivery.vue?vue&type=template&id=d2360276&"
import script from "./formClientDelivery.vue?vue&type=script&lang=js&"
export * from "./formClientDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports